<template>
  <van-cell title-class="mar-top-5" @click="clickCell"
            :class="'mt-cell-'+formattedMt.statusStyle">
    <template #title>
      <meeting-tags :formatted-mt="formattedMt"></meeting-tags>
      <p class="list-cell-subject mar-top-0 mar-btm-10">
        <van-icon v-show="formattedMt.isUserCheckin" class="text-md mar-rgt-5" name="certificate"></van-icon>
        <span v-if="isTimeMode">
          {{formattedMt.meetingTime}}<span class="text-sm">（{{formattedMt.fromNow}}）</span>
        </span>
        <span v-else>{{formattedMt.subject}}</span>
      </p>
    </template>
    <template #label>
      <div v-if="formattedMt.conferenceNum"
           class="list-cell-title text-md mar-btm-10 flex flex-space-between flex-align-center">
        <div>
          <i class="iconfont icon-shipin text-md mar-rgt-5"></i>
          <span v-if="formattedMt.tlcManufacturer">
            <tlc-logo :tlc-manufacturer="formattedMt.tlcManufacturer"></tlc-logo>
          </span>
          <span v-else class="text-lt">视频会议号</span>
          <span class="mar-lft-5">{{formattedMt.conferenceNum}}</span>
        </div>
        <van-button type="primary" v-if="checkMtStatus && joinMtHdr"
                    plain size="mini" @click="joinMeeting($event)">加入会议
        </van-button>
      </div>
      <div v-if="formattedMt.meetingRoom" class="list-cell-title text-md mar-btm-5">
        <i class="iconfont icon-dingwei text-md mar-rgt-5"></i>
        <span>{{formattedMt.meetingRoom}}</span>
      </div>
      <div :class="btmClass">
        <span class="mar-lft-5 pull-right">
          {{formattedMt.initiatorName || formattedMt.createdBy}} - {{formattedMt.numberOfPeople}}人</span>
        <span v-if="isTimeMode" class="text-hv">
          <i class="iconfont icon-huati text-md mar-rgt-5"></i>{{formattedMt.subject}}</span>
        <span v-else>
          <i class="iconfont icon-shijian text-md mar-rgt-5"></i>
          <span v-show="showDateTime">{{formattedMt.dateTime}} </span>
          {{formattedMt.meetingTime}}（{{formattedMt.fromNow}}）</span>
      </div>
    </template>
  </van-cell>
</template>

<script>
  import {commonConfig} from "../../../config/common";
  import {checkIsReactNative, joinMtInReactNative, queryTlcInfoByKey} from "../../../tools/utils";
  import MeetingTags from "./MeetingTags"
  import TlcLogo from "./TlcLogo"

  export default {
    props: {
      formattedMt: Object,
      isTimeMode: Boolean,
      showDateTime: Boolean,
      btmClass: String,
    },
    components: {
      TlcLogo,
      MeetingTags,
    },
    computed: {
      checkMtStatus() {
        return !commonConfig.endedStatus.includes(this.formattedMt && this.formattedMt.status)
      },
      joinMtHdr: function () {
        return checkIsReactNative()
      },
    },
    methods: {
      async joinMeeting(evt) {
        // console.log(this.formattedMt)
        evt.stopPropagation();  // 阻止冒泡
        if (this.formattedMt) {
          const tlcInfo = await queryTlcInfoByKey.call(this, ['conferenceNum', 'password'], this.formattedMt.mid);
          joinMtInReactNative(tlcInfo);
        }
      },
      clickCell() {
        this.$emit('click-cell')
      },
    }
  }
</script>

<style scoped>
</style>
